import React from 'react';
import SEO from "../common/SEO";
import Separator from "../elements/separator/Separator";
import CalltoActionThree from "../elements/calltoaction/CalltoActionThree";
import Layout from "./layout/Layout";
import SectionTitle from "../elements/sectionTitle/SectionTitle";
import ServiceSix from "../elements/service/ServiceSix";
import ServiceEight from "../elements/service/ServiceEight";


const DigitalMarketing = () => {
    return (
        <>
            <SEO title="CSMS Development"/>
            <Layout>
                <Separator/>
                {/* Start Service Area  */}
                <div className="service-area rn-section-gapTop">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-8">
                                <div className="content">
                                    <h3 className="title">Search Engine Optimization</h3>
                                    <h2 className="title">(SEO)</h2>
                                    <p className="mb--10">Maximize your online visibility with our effective and secure
                                        SEO
                                        services. Our team employs the latest, safest tools and strategies to gradually
                                        boost
                                        your website's ranking on Google and other search engines, resulting in
                                        increased
                                        website traffic. Our approach is comprehensive and strategic, combining
                                        optimized
                                        on-page elements with ongoing content creation for long-lasting, sustainable
                                        results
                                        from Google.</p>
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <img src="../images/seo/seo8.png" alt="split Images"/>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Service Area  */}
                <div className="rn-service-area rn-section-gap ">
                    <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <SectionTitle
                            textAlign="text-center"
                            radiusRounded=""
                            subtitle=""
                            title="Why do I need SEO (Search Engine Optimization)"
                            description="Partner with us and take your business to new heights with our expert marketing strategies. Our passion and experience will drive growth and bring new customers to your business through increased online visibility. Maximize your online exposure and reach with our proven methods for online marketing success."/>
                    </div>
                </div>
                    </div>
                </div>
                {/* Start Slider Area  */}
                <Separator/>
                {/* Start Service Area  */}
                <div className="rn-service-area rn-section-gap ">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <SectionTitle
                                    textAlign="text-center"
                                    radiusRounded=""
                                    subtitle=""
                                    title="Solutions We Provide For SEO"
                                    description="We are quite knowledgeable in search engine optimization, and we want you to take advantage of our experience."/>
                            </div>
                        </div>
                        {/* Start Slider Area  */}
                        <Separator/>
                        <ServiceEight
                            serviceStyle="service__style--1 bg-color-blackest radius mt--25 rbt-border"
                            textAlign="text-left"
                        />
                        <Separator/>
                        {/* End Slider Area  */}
                    </div>
                </div>
                {/* End Service Area  */}
                <Separator/>
                <CalltoActionThree/>
            </Layout>
        </>
    )
}
export default DigitalMarketing;
